
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { sslHandler } from './utils/sslHandler';

console.log("Application initializing - Version 2.0.0");

// Initialize SSL handler immediately
sslHandler.init();

// Enhanced detection for social media webviews
const userAgent = navigator.userAgent || '';
const isInstagramWebview = /Instagram/.test(userAgent);
const isFacebookWebview = /FBAN|FBAV/.test(userAgent);
const isChromeMobile = /Chrome/i.test(userAgent) && /Mobile/i.test(userAgent);

console.log(`Environment detected - Instagram: ${isInstagramWebview}, Facebook: ${isFacebookWebview}, Chrome Mobile: ${isChromeMobile}`);

// Apply environment-specific handling
if (isInstagramWebview || isFacebookWebview || isChromeMobile) {
  console.log("Applying enhanced SSL handling for detected environment");
  
  // Add environment classes for CSS targeting
  if (isInstagramWebview) document.documentElement.classList.add('instagram-webview');
  if (isFacebookWebview) document.documentElement.classList.add('facebook-webview');
  if (isChromeMobile) document.documentElement.classList.add('chrome-mobile');
  
  // Apply additional security bypasses
  document.documentElement.classList.add('ssl-bypass-active');
}

try {
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    throw new Error("Root element not found in the DOM");
  }
  
  const root = createRoot(rootElement);
  root.render(<App />);
  
  // Enhance links after render
  setTimeout(() => {
    sslHandler.enhanceLinks();
  }, 1000);
  
  console.log("Application rendered successfully");
} catch (error) {
  console.error("Error during application initialization:", error);
}
